const { isEmpty, get } = require('lodash');

const { entries } = Object;

const fields = () => {
  return {
    name: {
      type: 'string',
      label: '名称',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    isDirect: {
      type: 'boolean',
      label: '直販オーナー',
      initialValue: false,
    },
    premium: {
      type: 'boolean',
      label: 'プレミアムショップ',
      initialValue: false,
    },
  };
};

const expanderFields = () => {
  return {
    inventoryBuffer: {
      type: 'integer',
      label: '在庫バッファ数',
      initialValue: 0,
    },
  };
};

module.exports = {
  fields,
  expanderFields,
};
